// Return a copy of the object with a property recursively removed.
export function omitDeep(object, property) {
  return JSON.parse(
    JSON.stringify(object, (key, value) =>
      key === property ? undefined : value
    )
  );
}
